import React from 'react';
import GumtreeLogo from '@gumtree/ui-library/src/assets/gumtree-logo.png';
import BarkLogo from '@gumtree/ui-library/src/assets/bark-logo.png';
import NoImage from './noImg.svg';
import {
    QuoteDialogHeaderContainer,
    ProfileImage,
    ContentSection,
    Title,
    PartnershipSection,
    PartnershipText,
    LogoImage,
    BarkLogoImage
} from './index.style';

interface Props {
    profile: string;
    title: string;
}

const QuoteDialogHeader: React.FC<Props> = ({
    profile,
    title
}) => {
    return (
        <QuoteDialogHeaderContainer>
            <ProfileImage>
                {profile ? <img src={profile} alt="Profile" /> : <NoImage />}
            </ProfileImage>
            <ContentSection>
                <Title>{title}</Title>
                <PartnershipSection>
                    <LogoImage src={GumtreeLogo} alt="Gumtree" />
                    <PartnershipText>in partnership with</PartnershipText>
                    <BarkLogoImage src={BarkLogo} alt="BarkLogo" />
                </PartnershipSection>
            </ContentSection>
        </QuoteDialogHeaderContainer>
    );
};

export default QuoteDialogHeader;
